<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a
              v-if="$_createActionAllowed"
              class="btn btn_action btn_grey btn_duplicate"
              :title="'Duplikovat' | translate"
             @click.prevent.stop="duplicateEntity"
              v-translate>Duplikovat</a>
          <a v-if="!entity.global && $_createActionAllowed"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-if="entity.name">{{ entity.name }}</h1>
      </div>
      <div class="responsiveTabs r-tabs" v-if="entity">
        <ul class="tabs">
          <li :class="{'r-tabs-state-active' : this.$route.name === 'roleGroupsDetailBasicInfo'}">
            <a @click.prevent.stop="openRoute('roleGroupsDetailBasicInfo')" v-translate>Vlastnosti</a>
          </li>
          <li :class="{'r-tabs-state-active' : this.$route.name === 'roleGroupsDetailUsers'}">
            <a @click.prevent.stop="openRoute('roleGroupsDetailUsers')">{{ $gettext('Uživatelé') + ' (' + entity.user_count +')'}}</a>
          </li>
        </ul>
        <router-view
            :entity="entity"
            :edit_allowed_section_list = "edit_allowed_section_list"
        />
        <section class="buttons" v-if="this.$route.name === 'roleGroupsDetailBasicInfo' && $_updateActionAllowed">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
                type="submit"
                :value="'Uložit' | translate"
                class="btn"
                @click.prevent.stop="submitForm()">
          </p>
        </section>
      </div>
    </form>
  </div>
</template>

<script>
import roleGroups from "./mixins/roleGroups";
import detailActions from "@/components/mixins/detail-actions";

export default {
  name: "RoleGroupsDetail",
  mixins: [detailActions, roleGroups],
  created(RoleGroupsService) {
    this.entityService = RoleGroupsService;
    this.createdInit();
    this.getEditAllowedSectionList();
  },
  mounted() {
    if (this.$route.name === 'roleGroupsDetail') {
      this.openRoute('roleGroupsDetailBasicInfo');
    }
  },
  methods: {
    duplicateEntity() {
      this.$router.push({name: 'roleGroupsNew', query: {duplicate: this.entity.id,}});
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/RoleGroupsDetail.vue